export const SET_PROVIDERS = 'SET_PROVIDERS'

export const setThreePLProviders = (providers) => ({
  type: SET_PROVIDERS,
  providers,
})
